// noinspection JSDeprecatedSymbols

import { Platform } from 'react-native';

export const customWebStyle = () => {
  if (Platform.OS === 'web' && document) {
    const css =
      'input, textarea { outline: none !important;  } textarea { padding: 10px !important; } input[type=number] { -moz-appearance: textfield } input::-webkit-outer-spin-button, input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0;}';
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');

    head.appendChild(style);

    style.type = 'text/css';
    // @ts-expect-error
    if (style.styleSheet) {
      // @ts-expect-error
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }
};
